var _ = /* @__PURE__ */ ((A) => (A.Docx = ".docx", A.Doc = ".doc", A.Ttf = ".ttf", A.AD_PRT = ".AD_PRT", A.AD_SMP = ".AD_SMP", A.AD_ASM = ".AD_ASM", A.AD_DRW = ".AD_DRW", A))(_ || {});
export {
  _ as FileExtensionEnum
};
